import React from 'react/addons';
import cx from 'classnames';
import _ from 'underscore';
import {gettext, interpolate} from 'ofs/i18n';

import InfoTip from 'ofs/components/common/InfoTip';
import BedSizeChart from 'ofs/utils/BedSizeChart.jsx';
import PrestayContentSection from 'ofs/apps/bookings/prestay/views/PrestayContentSection';
import Row from 'ofs/forms/layout/row';
import Column from 'ofs/forms/layout/column';

const messages = {
  SHOW_CHART: gettext('Show bed size chart'),
  CHART_TITLE: gettext('Bed size naming chart'),
  ADD_GUEST_PROMPT: gettext('So we can prepare the home, please let us know which beds should be set up by selecting the number of people in each bed. Missing someone? Please return to the ‘Additional guests’ form above and provide their details – you can then assign any further beds.'),
  BED_CONFIGURATION_INACTIVE_PROMPT: gettext('Fill in the information of each additional guest above in order to proceed'),
  BED_CONFIGURATION_BUTTON: gettext('Choose beds to be made'),
  NONE: gettext('None'),
  AVAILABLE_EXTRAS: gettext('Available extras'),
  ADD_EXTRA: gettext('Add a %(extra)s'),
  BILLABLES: gettext(`Your chosen extras totalling <strong>%(currency)s%(sum)s</strong> will be added to your bill.`),
};

module.exports = function(config) {
  var BedConfiguration = React.createClass({
    contextTypes: {
      flux: React.PropTypes.object
    },

    getInitialState: function() {
      return {
        isActive: this.props.active || false
      };
    },

    onReset: function() {
      this.setState({
        isActive: false
      });
    },

    showBedSizeChart: function(){
      this.context.flux.actions.layers.addModal(<BedSizeChartModal />);
    },

    renderReadOnly: function(){
      var floors = _(this.props.model.getFloors()).map(function(floor){
        return <Floor model={floor} />;
      });

      return (
        <div className="bed-configuration">
          {config.readOnlyWithStatus ? this.renderStatus() : null}
          <div className="active">
            {floors}
          </div>
        </div>
      );
    },

    renderStatus: function(){
      var total = this.props.model.getTotalGuestsCount();
      var selected = this.props.model.getSelectedCount();

      return (
        <div className="ofs-BedConfiguration__StatusBar">
          <Row>
            <Column size="two-thirds">
              <div className="ofs-BedConfiguration__StatusBarItem u-text-bold">Guests assigned: {selected}/{total}</div>
              <div className="ofs-BedConfiguration__SleepsSelector">
                <SleepsSelector total={total} selected={selected} readOnly={true} />
              </div>
            </Column>
            <Column size="third">
              <div className="ofs-BedConfiguration__StatusBarItem ofs-BedConfiguration__StatusBarItem--right u-no-margin">
                <a onClick={this.showBedSizeChart}>{messages.SHOW_CHART}</a>
              </div>
            </Column>
          </Row>
        </div>
      );
    },

    renderActive: function(){
      var floors = _(this.props.model.getFloors()).map(function(floor){
        return <Floor model={floor} />;
      });

      var sum = this.props.model.sumBillables();
      var selection = JSON.stringify(this.props.model.getSelection());

      return (
        <PrestayContentSection title="Sleeping arrangements">
          <p className="ofs-Prestay__ContentIntro">{messages.ADD_GUEST_PROMPT}</p>

          {this.renderStatus()}
          <div className="active multi-stage-container">
            {floors}
            {sum > 0 ? <BillablesSummary sum={sum} /> : null}
          </div>
          <input type="hidden" name="bed_configuration" value={selection} />
        </PrestayContentSection>
      );
    },

    onActivateClick: function(event){
      event.preventDefault();
      this.setState({
        isActive: true
      });
    },

    renderInactive: function(){
      var isDisabled = !this.props.model.isAdditonalGuestsModelValid();

      var buttonClasses = cx({
        'ofs-Button': true,
        'disabled': isDisabled
      });

      return (
        <PrestayContentSection title="Sleeping arrangements">
          <div className="ofs-Prestay__PlaceholderBox">
            {isDisabled ? <p>{messages.BED_CONFIGURATION_INACTIVE_PROMPT}</p> : null}
            <button className={buttonClasses} disabled={isDisabled} onClick={isDisabled ? null : this.onActivateClick}>{messages.BED_CONFIGURATION_BUTTON}</button>
          </div>
        </PrestayContentSection>
      );
    },

    render: function () {
      if (config.readOnly){
        return this.renderReadOnly();
      } else {
        if(this.state.isActive){
          return this.renderActive();
        } else {
          return this.renderInactive();
        }
      }
    },

    componentDidMount: function(){
      this.props.model.on("change", this.forceUpdate.bind(this));
      this.props.model.on("reset", this.onReset);
    },

    componentWillUnmount: function(){
      this.props.model.off(null, null, this);
    }
  });

  var Floor = React.createClass({
    render: function(){
      var rooms = this.props.model.rooms.map(function(roomModel){
        return <Room model={roomModel} />;
      });

      var label = this.props.model.label;

      return (
        <div className="ofs-BedConfiguration__Bedroom">
          {label ? <h3>{label}</h3> : null}
          <ul className="ofs-List ofs-List--padded">
            {rooms}
          </ul>
        </div>
      );
    }
  });

  var Room = React.createClass({
    addExtra: function(extra){
      this.props.model.addExtra(extra.extra_id);
    },

    renderAvailableExtras: function(){
      var availableExtrasData;
      var availableExtras = null;

      availableExtrasData = this.props.model.getAvailableExtras();

      availableExtras = availableExtrasData.map(function(extra, i){
        var isNotLast = i < availableExtrasData.length - 1;
        var isActive = extra.active && !config.readOnly;
        var onClick = isActive ? this.addExtra.bind(null, extra) : null;

        var classes = cx({
          extra: true,
          active: isActive,
          inactive: !isActive
        });

        return (
          <span key={i}>
            <a className={classes} onClick={onClick}>{interpolate(messages.ADD_EXTRA, {extra: extra.name}, true)}
              {extra.price ? <span> ({config.bedBillablesCurrencySymbol}{extra.price})</span> : null}
            </a>
            {isNotLast ? <span className="seperator"> | </span> : null}
          </span>
        );
      }, this);

      if(availableExtras.length === 0){
        availableExtras = <span className="u-text-italic">{messages.NONE}</span>;
      }

      return (
        <p>{messages.AVAILABLE_EXTRAS}: {availableExtras} </p>
      );
    },

    render: function(){
      var label = this.props.model.get('label');
      var bedsModel = this.props.model.get('beds');

      var beds = bedsModel.map(function(bedModel, i){
        return <MetaBed key={i} model={bedModel} />;
      });

      return (
        <li className="ofs-List__Item">
          <h3>{label}</h3>
          <div className="ofs-BedConfiguration__BedsGroup">
            <ul className="ofs-List ofs-List--with-borders">
              {beds}
            </ul>
          </div>
          {!config.readOnly ? this.renderAvailableExtras() : null }
        </li>
      );
    }
  });

  var MetaBed = React.createClass({
    onSelect: function(count){
      var model = this.props.model;

      if(model.isSeparated()){
        model.join();
        model.setSelectedCount(1);
      } else if(model.isExtra() && count === 0) {
        model.remove();
      } else {
        model.setSelectedCount(count);
      }
    },

    _getBedSize: function(){
      var bedSize = this.props.model.get('size');
      bedSize = bedSize.toLowerCase().replace(/_/g, '-');
      bedSize = bedSize.substr(0,1).toUpperCase() + bedSize.substr(1);

      return bedSize;
    },

    render: function() {
      var model = this.props.model;
      var action, actionText, actionMethod, actionActive, actionClasses, actionIcons;
      var beds, label, sleeps, selected, max, description, price;

      if (!config.readOnly){
        if(model.isJoinable()){
          actionIcons = ["icon-double-bed"];
          actionMethod = model.join.bind(model);
          actionText = "Join to 1 " + this._getBedSize();
          actionActive = model.isCurrentlyJoinable();

        } else if(model.isSeparable()){
          actionIcons = ["icon-single-bed", "icon-single-bed"];
          actionMethod = model.separate.bind(model);
          actionText = "Split to 2 singles";
          actionActive = model.isCurrentlySeparable();

        } else if(model.isExtendable()){
          actionIcons = ["icon-double-bed"];
          actionMethod = model.extend.bind(model);
          actionText = "Extend to " + this._getBedSize();
          actionActive = model.isCurrentlyExtendable();

        } else if(model.isRetractable()){
          actionIcons = ["icon-single-bed"];
          actionMethod = model.retract.bind(model);
          actionText = "Retract to single";
          actionActive = model.isCurrentlyRetractable();

        } else if(model.isExtra()){
          actionIcons = ["icon-trash"];
          actionMethod = model.remove.bind(model);
          actionText = "Remove extra";
          actionActive = true;
        }
      }

      if(actionMethod){
        if(!actionActive){
          actionMethod = null;
        }

        actionClasses = cx({
          'disabled': !actionActive
        });

        actionIcons = actionIcons.map(function(symbol, i){
          return (
            <span key={i} className={"action-icon " + symbol}/>
          );
        });

        action = (
          <a onClick={actionMethod} className={actionClasses} disabled={!actionActive}>
            {actionText}
          </a>
        );
      }

      if(model.isSeparated()){
        beds = [
          <Bed key={1} label="Single Bed" sleeps={1} selected={1} max={1} onSelect={this.onSelect} />,
          <Bed key={2} label="Single Bed" sleeps={1} selected={1} max={1} onSelect={this.onSelect} action={action} />,
        ];
      } else {
        label = model.get('label');
        sleeps = model.getSleeps();
        selected = model.getSelectedCount();
        max = model.getMaxSelectedCount();
        description = model.getDescription();
        price = model.get('price');
        var iconClass = model.getBedIconClass();

        if(model.isExtended()){
          label = this._getBedSize() + " bed";
        }

        beds = [
          <Bed
            key={3}
            label={label}
            price={price}
            sleeps={sleeps}
            selected={selected}
            max={max}
            onSelect={this.onSelect}
            action={action}
            description={description}
            iconClass={iconClass}
          />
        ];
      }

      return (

        <li className="ofs-List__Item">
          {beds}
        </li>
      );
    }
  });

  var Bed = React.createClass({
    contextTypes: {
      flux: React.PropTypes.object
    },

    render: function(){
      const {label, sleeps, selected, max, description, price, action} = this.props;

      return (
        <div className="ofs-BedConfiguration__Bed">
          <div className="ofs-BedConfiguration__SleepsSelector">
            <SleepsSelector selected={selected} total={sleeps} onSelect={this.props.onSelect} readOnly={config.readOnly} max={max} />
          </div>
          <span className="ofs-BedConfiguration__ExtrasItem">
            <span className="ofs-InfoTip__Label ofs-InfoTip__Label--left">{label}
              {price ?
                <span> ({config.bedBillablesCurrencySymbol + price})</span>
              : null}
            </span>
              {description ? <InfoTip flux={this.context.flux} small={true}>{description}</InfoTip> : null}
          </span>
          <div className="u-pull-right">{action}</div>
        </div>
      );
    },
  });

  var BillablesSummary = React.createClass({
    render: function(){
      var sum = this.props.sum;

      return (
        <div className="ofs-BedConfiguration__Billables" dangerouslySetInnerHTML={{__html: interpolate(messages.BILLABLES, {currency: config.bedBillablesCurrencySymbol, sum}, true)}}></div>
      );
    }
  });

  var BedSizeChartModal = React.createClass({
    render: function() {
      return (
        <div className="bed-size-chart">
          <h2>{messages.CHART_TITLE}</h2>
          <BedSizeChart />
        </div>
      );
    }
  });

  var SleepsSelector = React.createClass({
    getInitialState: function(){
      return {
        hoverIndex: -1
      };
    },

    onClick: function(count){
      count = this._correctNewSelectedValue(count);
      this.props.onSelect(count);

      this.onMouseLeave();
    },

    _correctNewSelectedValue: function(selected){
      if(selected <= this.props.selected){
        selected--;
      }

      var max = this.props.max;
      return Math.min(max, selected);
    },

    onMouseEnter: function(count){
      this.setState({
        hoverIndex: Math.min(count, this.props.max)
      });
    },

    onMouseLeave: function(){
      this.setState({
        hoverIndex: -1
      });
    },

    render: function(){
      var heads = [];
      const {total} = this.props;
      var {selected} = this.props;
      var readOnly = !!this.props.readOnly;
      var max = this.props.max || selected;

      if(this.state.hoverIndex > -1 && !readOnly){
        selected = this._correctNewSelectedValue(this.state.hoverIndex);
      }

      _(total).times(function(i){
        var isSelected = i < selected;
        var isSelectedable = !readOnly && !isSelected && i < max;
        var isUnselectable = !isSelected && !isSelectedable;

        var classes = {
          'ofs-BedConfiguration__Head': true,
          'font-icon': true
        };

        if(isSelected){
          classes['selected']=true;
          classes['icon-profile']=true;
        } else if(isSelectedable) {
          classes['selectable']=true;
          classes['icon-profile-outline']=true;
        } else { //unselectable
          classes['ofs-BedConfiguration__Head--unselectable']=true;
          classes['icon-profile']=true;
        }

        classes = cx(classes);

        var listeners = {};
        ['onClick', 'onMouseEnter', 'onMouseLeave'].forEach(function(eventName){
          if(isUnselectable || readOnly){
            listeners[eventName] = null;
          } else {
            listeners[eventName] = this[eventName].bind(null, i+1);
          }
        }, this);

        heads.push(
          <span className={classes} key={i+1} onClick={listeners.onClick}
                onMouseEnter={listeners.onMouseEnter} onMouseLeave={listeners.onMouseLeave}/>
        );
      }, this);

      return (
        <div>
          {heads}
        </div>
      );
    }
  });

  return BedConfiguration;
};



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/guests/views/bed-configuration.jsx
 **/